<template>
    <div class="mb-4">
        <template v-for="(item, idx) of items" :key="idx">
            <SearchPromotionCategoryItem :item="item"></SearchPromotionCategoryItem>
        </template>
    </div>
</template>
<script>
import SearchPromotionCategoryItem from "./SearchPromotionCategoryItem.vue";
//helper
import Locale from "@/helper/locale/Locale.js";
//service
import { SubDashboardConfigBuilder } from "@/core/Campaign/config/DashboardConfigModel.js";
import BzbsDashboard from "@/core/Campaign/service/BzbsDashboard.js";

// mixins
import LocaleMixin from "@/mixin/LocaleMixin"
import ErrorApiMixin from "@/mixin/ErrorApiMixin"

// config
import ConfigManager from "@/config/ConfigManager";

export default {
    name: 'SearchPromotionList',
    props: {
        modalController: { type: Object }
    },
    components: {
        SearchPromotionCategoryItem
    },
    mixins: [LocaleMixin, ErrorApiMixin],
    emits: ["onLoaded", "onError"],
    data: function () {
        return {
            dashboardConfig: ConfigManager.getDashboardConfig(),
            items: []
        }
    },
    computed: {},
    mounted: function () {
        this.getCategory()
    },
    methods: {
        getCategory: function () {
            var dashboardConfig = ConfigManager.getDashboardSearchPromotionConfig();
            var configBuilder = new SubDashboardConfigBuilder();
            configBuilder.setLocale(Locale.getLocaleCode());

            var params = configBuilder.create().getParams();
            BzbsDashboard.apiGetSubDashboard(params, dashboardConfig).subscribe((data) => {
                this.items = data;

                console.log(this.items)
                // this.modalController.loadingModal.hide()
                this.$emit("onLoaded")
            }, (err) => {
                // this.modalController.loadingModal.hide()
                this.errorApi(err)
                // console.log(err);
            });
        },
    }
}
</script>
